const getDbnsfp = (state) => state.variantResult && state.variantResult.dbnsfp;

const getGerp = (state) => state.variantResult && state.variantResult.gerp;

const getPhastCons100Way = (state) =>
  state.variantResult && state.variantResult.phastcons100way;

const getPhyloP100Way = (state) =>
  state.variantResult && state.variantResult.phylop100way;

const getSchemaProperties = (state) => state.schema && state.schema.properties;

export {
  getDbnsfp,
  getSchemaProperties,
  getGerp,
  getPhastCons100Way,
  getPhyloP100Way,
};
